module.exports = __webpack_public_path__ + "img/text_medium.efbf1576.png";